import { docsConsoleMembersIntro, docsConsoleMembersTitle } from 'Clepit/translations';
import type { SupportedLanguage } from '@bomdisoft/translations';
import type { EditorData } from '@clepit/core';

/** Derived from `app/[lang]/settings/{members,groups}`, which follow the User
 * Management Record. */
export const buildConsoleMembers = (language: SupportedLanguage): EditorData => ({
  blocks: [
    { data: { html: docsConsoleMembersTitle[language], level: 'h1' as const }, type: 'header' },
    { data: { html: docsConsoleMembersIntro[language] }, type: 'paragraph' },

    { data: { alt: 'The Members settings screen', caption: 'Members: the seats chip, the Users and Roles tabs, and the roster.', url: '/images/docs/console/members/screen-light.png' }, type: 'image' },
    { data: { alt: 'The Members settings screen, dark theme', caption: 'Members: the seats chip, the Users and Roles tabs, and the roster.', url: '/images/docs/console/members/screen-dark.png' }, type: 'image' },

    { data: { html: 'Users', level: 'h2' as const }, type: 'header' },
    {
      data: {
        html: 'The roster with search, sorting and a role filter, and a seats chip in the page header that meters how many seats are used against the plan (absent on an uncapped plan). Pending invitations sit in a band above the roster that folds away and disappears entirely when nothing is pending. Selecting rows raises a bar that counts them and removes them, or moves them to a role, in one action. Inviting takes a list of emails and a role, and reports per-address results, so one bad address does not hide the nine that worked. Who may invite is a Workspace setting.',
      },
      type: 'paragraph',
    },

    { data: { html: 'Roles', level: 'h2' as const }, type: 'header' },
    {
      data: {
        html: 'The Roles tab lists the system roles and the custom roles the workspace has defined, with how many members hold each. A role editor groups privileges by area and only offers what you yourself hold with grant option, counting what is yours to give; deleting a role that members hold names who loses what before it runs. The same editor serves the role picker on a member, so the two never drift apart.',
      },
      type: 'paragraph',
    },

    { data: { html: 'Groups', level: 'h2' as const }, type: 'header' },
    {
      data: {
        html: 'Named groups with a description and a member picker, created and edited in place. Groups exist to be granted access as one unit, so organising people precedes sharing documents with them.',
      },
      type: 'paragraph',
    },

    { data: { html: 'Where this meets the docs', level: 'h2' as const }, type: 'header' },
    {
      data: {
        html: 'Enterprise sign-in for these members is configured under <a href="./sso">SSO</a>, and every change made here lands in the <a href="./audit">audit log</a>.',
      },
      type: 'paragraph',
    },
  ],
  time: 1_745_000_000_000,
  version: '1.0.0',
});
